import React from 'react';
import { FadeIn } from './FadeIn';
import { UtensilsCrossed, Activity, Pill, Brain } from 'lucide-react';
export function FailedApproaches() {
  const approaches = [{
    icon: <UtensilsCrossed className="w-8 h-8 text-rose-gold" data-id="element-15" />,
    text: 'Las dietas de 1,200 calorías estresan tus glándulas adrenales y bloquean tu metabolismo.'
  }, {
    icon: <Activity className="w-8 h-8 text-rose-gold" data-id="element-16" />,
    text: 'El ejercicio de alto impacto eleva el cortisol, provocando más inflamación abdominal.'
  }, {
    icon: <Pill className="w-8 h-8 text-rose-gold" data-id="element-17" />,
    text: 'Los suplementos genéricos no contienen los fitoestrógenos específicos que tu receptor hormonal necesita ahora.'
  }, {
    icon: <Brain className="w-8 h-8 text-rose-gold" data-id="element-18" />,
    text: "Confiar solo en la 'fuerza de voluntad' es imposible cuando tus hormonas dictan tu nivel de fatiga."
  }];
  return <section className="py-20 px-6 md:px-12 bg-blush/40" data-id="element-19">
      <div className="max-w-4xl mx-auto" data-id="element-20">
        <FadeIn data-id="element-21">
          <div className="text-center mb-12" data-id="element-22">
            <h2 className="text-3xl md:text-4xl font-serif font-bold text-warm-dark mb-4" data-id="element-23">
              ¿Por Qué Lo Que Has Intentado No Funciona?
            </h2>
            <div className="w-24 h-1 bg-rose-gold mx-auto rounded-full" data-id="element-24"></div>
          </div>
        </FadeIn>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-25">
          {approaches.map((item, index) => <FadeIn key={index} delay={index * 0.1} data-id="element-26">
              <div className="bg-white p-8 rounded-2xl shadow-sm border border-blush h-full flex flex-col items-center text-center hover:shadow-md transition-shadow duration-300" data-id="element-27">
                <div className="w-16 h-16 bg-cream rounded-full flex items-center justify-center mb-6" data-id="element-28">
                  {item.icon}
                </div>
                <p className="text-warm-dark/80 font-sans text-lg leading-relaxed" data-id="element-29">
                  {item.text}
                </p>
              </div>
            </FadeIn>)}
        </div>
      </div>
    </section>;
}